
import { Box } from '@mui/material';
import React from "react";
import {
    required, TextInput
} from "react-admin";
import { useFormContext, useWatch } from 'react-hook-form';
import 'handsontable/dist/handsontable.full.css';
import { Button } from '@mui/material';
import { DriverNIDInput,DriverNIDInputBlacklist } from '../OdsSearch/vehicle';





export const CustomNidSearch = (meta) => {
    const {source, index, is_required}=meta;
  
    return (
      <DriverNIDInput
          source={source}
          onDriverNotFound={() => {
            // Handle driver not found logic here if needed
          }} />
  
  
    );
  };

  export const CustomNidSearchBlacklist = (meta) => {
    const {source, index, is_required}=meta;
  
    return (
      <DriverNIDInputBlacklist
          source={source}
          onDriverNotFound={() => {
            // Handle driver not found logic here if needed
          }} />
  
  
    );
  };


  


export const CustomNidActions = ({ source, label }) => {
    const { setValue, control } = useFormContext();
  
    // Watch the 'editingDriverMeta' and 'driver_meta_data' fields
    const editingDriverMeta = useWatch({
      control,
      name: 'editingDriverMeta',
      defaultValue: false,
    });
  
    const driverMetaData = useWatch({
      control,
      name: 'driver_meta_data',
      defaultValue: null,
    });
  
    const handleEditDriverMeta = () => {
      setValue('editingDriverMeta', true);
      setValue('driver_meta_data.is_ods', false);
    };
    const handleSaveDriverMeta = () => {
      setValue('editingDriverMeta', false);
      setValue('driver_meta_data.is_ods', false);
    };
  
    const handleCancelEdit = () => {
      setValue('editingDriverMeta', false);
    };
  
  
  
    return (
  
      <>
    
  
        {driverMetaData && (
                <>
            {!editingDriverMeta ? (
              <Button
                onClick={handleEditDriverMeta}
                variant="contained"
                color="primary"
                style={{ marginTop: '1em' }}
              >
                تعديل بيانات السائق
              </Button>
            ) : (
              <Box mt={2} display="flex" gap={2}>
                <TextInput
                  source="driver_meta_data.edit_reason"
                  label="سبب تعديل السجل"
                  validate={required()}
                  fullWidth
                />
                    <Button
                onClick={handleSaveDriverMeta}
                variant="contained"
                color="primary"
                style={{ marginTop: '1em' }}
              >
                تعديل بيانات السائق
              </Button>
                <Button
                  onClick={handleCancelEdit}
                  variant="outlined"
                  color="secondary"
                  style={{ alignSelf: 'flex-end' }}
                >
                  تراجع عن التعديل
                </Button>
              </Box>
            )}
       
       </>
  
        )}
  
  </>
  
    );
  };
  


export const CustomVehicleActions = ({ source, label }) => {
    const { setValue, control } = useFormContext();
  
    // Watch the 'editingVehicleMeta' and 'Vehicle_meta_data' fields
    const editingVehicleMeta = useWatch({
      control,
      name: 'editingVehicleMeta',
      defaultValue: false,
    });
  
    const VehicleMetaData = useWatch({
      control,
      name: 'Vehicle_meta_data',
      defaultValue: null,
    });
  
    const driverMetaData = useWatch({
      control,
      name: 'driver_meta_data',
      defaultValue: null,
    });
  
  
  
    const handleEditVehicleMeta = () => {
      setValue('editingVehicleMeta', true);
      setValue('Vehicle_meta_data.is_ods', false);
    };
    const handleSaveVehicleMeta = () => {
      setValue('editingVehicleMeta', false);
      setValue('Vehicle_meta_data.is_ods', false);
    };
  
    const handleCancelEdit = () => {
      setValue('editingVehicleMeta', false);
    };
  
  
  
    return (
  
      <>
    
  
        {driverMetaData &&  (
                <>
            {!editingVehicleMeta ? (
              <Button
                onClick={handleEditVehicleMeta}
                variant="contained"
                color="primary"
                style={{ marginTop: '1em' }}
              >
                تعديل بيانات الحافلة
              </Button>
            ) : (
              <Box mt={2} display="flex" gap={2}>
                <TextInput
                  source="Vehicle_meta_data.edit_reason"
                  label="سبب تعديل السجل"
                  validate={required()}
                  fullWidth
                />
                    <Button
                onClick={handleSaveVehicleMeta}
                variant="contained"
                color="primary"
                style={{ marginTop: '1em' }}
              >
                تعديل بيانات الحافلة
              </Button>
                <Button
                  onClick={handleCancelEdit}
                  variant="outlined"
                  color="secondary"
                  style={{ alignSelf: 'flex-end' }}
                >
                  تراجع عن التعديل
                </Button>
              </Box>
            )}
       
       </>
  
        )}
  
  </>
  
    );
  };
  